<template>
  <div class="custom-container" v-loading.fullscreen.lock="isLoading">
    <el-container class="category-title my-2">Create Customer Account</el-container>
    <el-row>
      <el-col :span="12">
        <el-form label-position="left" ref="customer" label-width="120px" :model="customer">
          <el-tabs v-model="activeName">
            <el-tab-pane label="User Owner" name="first">
              <CreateOwner :save="save" :customer="customer" />
            </el-tab-pane>
            <el-tab-pane label="Sub-Store Data" name="second">
              <CreateSubStore :customer="customer" />
            </el-tab-pane>
            <el-tab-pane label="User Employee" name="third">
              <CreateEmploye :customer="customer" />
            </el-tab-pane>
          </el-tabs>
          <el-col>
            <el-form-item label="Active" prop="active">
              <el-switch v-model="customer.is_active"></el-switch>
            </el-form-item>
            <el-form-item>
              <el-button @click="$router.go(-1)">Kembali</el-button>
              <el-button type="primary" @click="save">Simpan</el-button>
            </el-form-item>
          </el-col>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import CreateOwner from "./Owner/Create";
import CreateSubStore from "./SubStore/Create";
import CreateEmploye from "./Employe/Create";
export default {
  components: {
    CreateOwner,
    CreateSubStore,
    CreateEmploye
  },
  data: () => ({
    activeName: "first",
    customer: {
      customer_number: "",
      customer_name: "",
      country: "",
      address: "",
      city: "",
      postal_code: "",
      state: "",
      province: "",
      primary_phone_number: "",
      primary_phone_area_code: "",
      branch_code: "",
      customer_type: "",
      customer_class_code: "",
      is_active: true,
      external_user: [
        {
          user_id: "",
          customer_number: "",
          fullname: "",
          user_name: "",
          email: "",
          user_type: 0,
          password: "",
          is_active: true
        }
      ],
      customer_address: [
        {
          customer_address_id: "",
          customer_id: "",
          country: "",
          address: "",
          city: "",
          postal_code: "",
          state: "",
          province: "",
          primary_phone_number: "",
          primary_phone_area_code: "",
          contact_person: "",
          contact_phone_number: "",
          address_type: 0,
          oracle_bill_to_site_use_id: "",
          oracle_ship_to_site_use_id: "",
          order: "",
          is_active: true
        },
        {
          customer_address_id: "",
          customer_id: "",
          country: "",
          address: "",
          city: "",
          postal_code: "",
          state: "",
          province: "",
          primary_phone_number: "",
          primary_phone_area_code: "",
          contact_person: "",
          contact_phone_number: "",
          address_type: 1,
          oracle_bill_to_site_use_id: "",
          oracle_ship_to_site_use_id: "",
          order: "",
          is_active: true
        }
      ]
    },
    valid: true,
    draft: false
  }),
  computed: {
    ...mapState({
      isLoading: state => state.customer.customer.isLoading
    })
  },
  methods: {
    ...mapActions({
      createOwner: "customer/CreateOwner"
    }),
    save() {
      this.$refs.customer.validate(valid => {
        if (valid) {
          this.createOwner(this.customer);
          this.snackbar = true;
        } else {
          return false;
        }
      });
    },
    reset() {
      this.$refs.form.reset();
    }
  }
};
</script>

<style>
.custom-tab .v-tabs__bar {
  background-color: transparent;
}
.custom-tab .v-tabs__item--active {
  background-color: #15216a !important;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  color: #fff;
}
</style>
